// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","InstagramEmbed":"bal_a","InstagramEmbed__mask":"bal_b bhc_bi bhc_bo bhc_wx"};